// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"05615927","190":"b0ff7b6b","856":"b06618d7"}[chunkId] + ".chunk.js";
};